<template lang="html">
<div class="sign-in-page">
    <form @submit.prevent="login({ email, password })">
        <div class="form-group">
            <input type="text" placeholder="Email" v-model="email">
        </div>
        <div class="form-group">
            <input type="password" placeholder="Пароль" v-model="password">
        </div>
        <button type="submit">Login</button>
    </form>
</div>
</template>

<script>
export default {
	data() {
		return {
			email: "",
			password: ""
		}
	},
	methods: {
		login() {
            var formData = new FormData()
            formData.append('email', this.email)
            formData.append('password', this.password)

			this.$store.dispatch("auth/login", formData).then((resp) => {
                if (resp.data.success) {
                    this.$router.push("/")
                } else {
                }
			})
		}
	},
}
</script>

<style lang="scss" scoped>
.sign-in-page {
    flex: 1 1 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    form {
        display: block;
        max-width: 500px;
        width: 100%;
        margin: 0 auto;
        .form-groups {
            display: flex;
            margin: 0 -5px 10px;
            .form-group {
                margin: 0 5px;
                flex: 1 1 1px;
            }
        }
        .form-group {
            margin-bottom: 10px;
            label {
                font-size: 13px;
                display: block;
                margin-bottom: 8px;
                font-weight: 300;
            }
        }
        input[type=text],
        input[type=password],
        select {
            border: 1px solid #F0F0F0;
            border-radius: 4px;
            padding: 0 15px;
            width: 100%;
            height: 40px;
            font-size: 14px;
            outline: none;
            background: #fff;
            &:focus {
                border-color: darken(#F0F0F0, 15%);
            }
        }
        .form-desc {
            margin-bottom: 10px;
            font-size: 12px;
        }
        button {
            width: 100%;
            height: 40px;
        }
    }
}
</style>
